import * as React from "react";

import { DomElementHack } from "../../Commons/DOM/DomElementHack";
import { emptyRef } from "../../TypingUtils";

import { useTourElementsRegistry } from "./TourElementsRegistryContext";

interface TourTargetElementProps {
    controlId: undefined | string;
    children: React.ReactElement;
}

export function TourTargetElement(props: TourTargetElementProps): JSX.Element {
    const elementRef = React.useRef<DomElementHack>(emptyRef);
    const tourElementsRegistry = useTourElementsRegistry();

    React.useEffect(() => {
        if (props.controlId) {
            tourElementsRegistry.registerReactRef(props.controlId, elementRef);
        }
        return () => {
            if (props.controlId) {
                tourElementsRegistry.unregisterReactRef(props.controlId, elementRef);
            }
        };
    }, [props.controlId]);

    return <DomElementHack ref={elementRef}>{props.children}</DomElementHack>;
}
